import { render, staticRenderFns } from "./Who.vue?vue&type=template&id=ec5a3b36"
import script from "./Who.vue?vue&type=script&lang=js"
export * from "./Who.vue?vue&type=script&lang=js"
import style0 from "./Who.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports